var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoUbicacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.80588 0 0 3.69394 0 8.25C0 10.044 0.605979 11.6903 1.61323 13.0384C1.63129 13.0708 1.63412 13.1068 1.65467 13.1378L7.32133 21.3878C7.58413 21.7704 8.02683 22 8.5 22C8.97317 22 9.41587 21.7704 9.67867 21.3878L15.3453 13.1378C15.3662 13.1068 15.3687 13.0708 15.3868 13.0384C16.394 11.6903 17 10.044 17 8.25C17 3.69394 13.1941 0 8.5 0ZM8.5 11C6.93529 11 5.66667 9.76869 5.66667 8.25C5.66667 6.73131 6.93529 5.5 8.5 5.5C10.0647 5.5 11.3333 6.73131 11.3333 8.25C11.3333 9.76869 10.0647 11 8.5 11Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoUbicacion);
export default __webpack_public_path__ + "static/media/icono_ubicacion.0b49c88a641d20e00514d38f1ca5428a.svg";
export { ForwardRef as ReactComponent };